const PROJECTS_FLOW_CLUSTER = {
    subclusters: [],
};

export { PROJECTS_FLOW_CLUSTER };
